import { RouteConfig } from 'vue-router';
import ua from '@xl/user-agent';
const { is_xl_driver_app, isIOS } = ua.parse();

/** 这几个都是不可见字符，在设置页面空白title的时候，ios下，一个字符不生效，故准备了一串 */
const iosInvisibleChars = '\ufeff\u2028\u2029';
/** 上述不可见字符在安卓下不都是不可见字符，故取一个 */
const androidInvisibleChars = '\ufeff';
const invisibleChars = isIOS ? iosInvisibleChars : androidInvisibleChars;

const joinRouter: RouteConfig[] = [
  {
    name: 'Register',
    path: '/register',
    component: () =>
      import(/* webpackChunkName: "Register" */ '@/views/register/index.vue'),
    meta: {
      title: '小拉出行',
      style: 'home',
    },
  },
  {
    name: 'Register_v2',
    path: '/register_v2',
    component: () =>
      import(/* webpackChunkName: "Register" */ '@/views/register/index.vue'),
    meta: {
      title: '小拉出行',
      style: 'home',
    },
  },
  {
    name: 'Register',
    path: '/carpool-register',
    component: () =>
      import(/* webpackChunkName: "CarpoolRegister" */ '@/views/register/carpool.vue'),
    meta: {
      title: '小拉出行',
      style: 'home',
    },
  },
  {
    name: 'DriverJoinRequire',
    path: '/driver-join-require',
    component: () =>
      import(
        /* webpackChunkName: "DriverJoinRequire" */ '@/views/driver-join-require/index.vue'
      ),
    meta: {
      title: '司机加入要求',
      style: 'navigation',
    },
  },
  {
    name: 'StepJoinCity',
    path: '/stepJoinCity',
    component: () =>
      import(
        /* webpackChunkName: "StepJoinCity" */
        '@/views/step-joinCity/index.vue'
      ),
    meta: {
      title: '小拉出行',
      style: 'home',
    },
  },
  {
    name: 'StepJoinCity_v2',
    path: '/stepJoinCity_v2',
    component: () =>
      import(
        /* webpackChunkName: "StepJoinCity" */
        '@/views/step-joinCity/index.vue'
      ),
    meta: {
      title: '小拉出行',
      style: 'home',
    },
  },
  {
    name: 'StepFirst',
    path: '/stepFirst',
    component: () =>
      import(
        /* webpackChunkName: "StepFirst" */
        '@/views/step-first/index.vue'
      ),
    meta: {
      title: '加入小拉出行',
      style: 'close',
    },
  },
  {
    name: 'StepSecond',
    path: '/stepSecond',
    component: () =>
      import(
        /* webpackChunkName: "StepSecond" */
        '@/views/step-second/index.vue'
      ),
    meta: {
      title: '加入小拉出行',
      style: 'close',
    },
  },
  {
    name: 'StepThird',
    path: '/stepThird',
    component: () =>
      import(
        /* webpackChunkName: "StepThird" */
        '@/views/step-third/index.vue'
      ),
    meta: {
      title: '加入小拉出行',
      style: 'close',
    },
  },
  {
    name: 'Welcome',
    path: '/welcome',
    component: () =>
      import(/* webpackChunkName: "Welcome" */ '@/views/welcome/index.vue'),
    meta: {
      title: '小拉出行',
      style: 'home',
    },
  },
  {
    name: 'FaceRecognition',
    path: '/faceRecognition',
    component: () =>
      import(
        /* webpackChunkName: "FaceRecognition" */
        '@/views/face-recognition/index.vue'
      ),
    meta: {
      title: is_xl_driver_app ? invisibleChars : '加入小拉出行',
      style: 'close',
    },
  },
  {
    name: 'AuditResult',
    path: '/auditResult',
    component: () =>
      import(
        /* webpackChunkName: "AuditResult" */
        '@/views/audit-result/index.vue'
      ),
    meta: {
      title: '审核结果',
      style: 'home',
    },
  },
  {
    name: 'AuditRefuse',
    path: '/auditRefuse',
    component: () => import('@/views/audit-refuse/index.vue'),
    meta: {
      title: '审核结果',
      style: 'home',
    },
  },
  {
    name: 'IframeAgreement',
    path: '/iframeAgreement',
    component: () =>
      import(
        /* webpackChunkName: "AuditResult" */
        '@/views/iframe-agreement/index.vue'
      ),
    meta: {
      title: '人脸识别协议',
      style: 'navigation',
    },
  },
  {
    name: 'SuccessReg',
    path: '/successReg',
    component: () =>
      import(
        /* webpackChunkName: "SuccessReg" */
        '@/views/success-reg/index.vue'
      ),
    meta: {
      title: '小拉出行',
      style: 'home',
    },
  },
  {
    name: 'DriverAuditSubmit',
    path: '/driver-audit/submit',
    component: () =>
      import(
        /* webpackChunkName: "DriverAuditSubmit" */
        '@/views/driver-audit/submit.vue'
      ),
    meta: {
      title: ' ',
      style: 'navigation',
    },
  },
  {
    name: 'DriverAuditInfoSupplement',
    path: '/driver-audit/supplement',
    component: () =>
      import(
        /* webpackChunkName: "DriverAuditInfoSupplement" */
        '@/views/driver-audit/supplement.vue'
      ),
    meta: {
      title: '补充资料',
      style: 'navigation',
    },
  },
  {
    name: 'PicturePage',
    path: '/picture-page',
    component: () =>
      import(
        /* webpackChunkName: "PicturePage" */
        '@/views/picture-page/index.vue'
      ),
    meta: {
      title: '小拉出行',
      style: 'navigation',
    },
  },
  {
    name: 'QrcodeWechat',
    path: '/qrcode-wechat',
    component: () =>
      import(
        /* webpackChunkName: "QrcodeWechat" */
        '@/views/qrcode-wechat/index.vue'
      ),
  },
  {
    name: 'TransferHll',
    path: '/transfer/hll',
    component: () =>
      import(
        /* webpackChunkName: "TransferHll" */
        '@/views/transfer/hll.vue'
      ),
    meta: {
      title: '小拉出行',
      style: 'home',
    },
  },
  {
    name: 'JoinCommonQuestion',
    path: '/join-common-question',
    component: () =>
      import(
        /* webpackChunkName: "JoinCommonQuestion" */
        '@/views/join-common-question/index.vue'
      ),
    meta: {
      title: '常见问题',
      style: 'navigation',
    },
  },
  {
    name: 'OnlineCertificates',
    path: '/online-certificates',
    component: () =>
      import(
      /* webpackChunkName: "OnlineCertificates" */
        '@/views/online-certificates/index.vue'
      ),
    meta: {
      title: '加入小拉出行',
      style: 'navigation',
    },
  },
  {
    name: 'DrivingLicenseVideoProof',
    path: '/driving-license-video-proof',
    component: () =>
      import(
        /* webpackChunkName: "DrivingLicenseVideoProof" */
        '@/views/driving-license-video-proof/index.vue'
      ),
    meta: {
      title: '行驶证视频证明',
      style: 'navigation',
    },
  },
];

export default joinRouter;
